import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Option } from '@modules/elements/types/option';
import { UsersService } from '@modules/users/services/users.service';
import { Team } from '@modules/users/types/user';
import { catchError, of, Subject, takeUntil } from 'rxjs';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
    selector: 'app-add-user',
    templateUrl: './add-user.component.html',
    styleUrl: './add-user.component.less',
    standalone: false
})
export class AddUserComponent implements OnInit {

  // Public
  public email: string = '';
  public role: string = '';
  public roleOptions: Option<string>[] = [
    new Option('user', 'User'),
    new Option('admin', 'Admin'),
  ];
  public teamsOptions: Option<string>[] = [];
  public teamId?: string;
  public team?: Team;
  public inviteLink?: string;
  public error?: string;

  // Private
  private alive = new Subject<void>();

  /**
   * Constructor
   */

  constructor(
    public dialogRef: MatDialogRef<AddUserComponent>,
    private usersService: UsersService,
    private clipboard: Clipboard
  ) { }

  /**
   * Component lifecycle
   */

  ngOnInit(): void {
    // Get Team Users
    this.usersService.getTeams()
      .pipe(takeUntil(this.alive))
      .subscribe(teams => this.teamsOptions = teams.map(team => new Option(team?.id || '', team?.name || '')));
    // Get Team Users
    this.usersService.getAccountTeam()
      .pipe(takeUntil(this.alive))
      .subscribe(team => this.team = team);
  }

  ngOnDestroy(): void {
    this.alive.next();
    this.alive.complete();
  }

  /**
   * Methods
   */

  updateRole(option: any): void {
    this.role = option.value;
  }

  updateTeam(option: any): void {
    this.teamId = option.value;
  }

  close(): void {
    this.dialogRef.close();
  }

  invite(): void {
    this.error = undefined;
    if (this.email.length) {
      if (!this.team?.permissions?.includes('admin:all')) {
        this.teamId = this.team?.id;
      }
      if (this.teamId) {
        this.usersService.inviteUser(this.email, this.role, this.teamId)
          .pipe(
            catchError(error => {
              console.log('[Invite][ERROR] ', error);
              if (error) {
                this.error = ((error.error.message instanceof Array) ? error.error.message.join('\n') : error.error.message);
              }
              return of();
            })
          )
          .subscribe(data => {
            this.inviteLink = data?.link;
          })
      }
    }
  }

  copyLink(): void {
    if (this.inviteLink) {
      this.clipboard.copy(this.inviteLink);
    }
  }

}
